// @ts-ignore
import { adminWebUrl } from '../../environment/environment';
import React, { useEffect, useState, useRef } from 'react';
import { HashRouter as Router } from 'react-router-dom';
import { ErrorBoundary } from '@components/ErrorBoundary';
import { NavLink, Link, useNavigate } from 'react-router-dom';
import longlogo from '../../images/landing/longlogo.svg';
import aboutus from '../../images/landing/aboutsus.png';
import prblmbanner from '../../images/landing/manbanner.png';
// import solbanner from '../../images/landing/updatedSolution.svg';
import solbanner from '../../images/landing/desktopFrame.png';
import referrals from '../../images/landing/Referrals.png';
import Referrers from '../../images/landing/Referrers.png';
import CompaniesIRefer from '../../images/landing/CompaniesIRefer.png';
import referus from '../../images/landing/referus.png';
import InviteReferrer from '../../images/landing/InviteReferrer.png';
import social from '../../images/landing/social.png';
import maps from '../../images/landing/map.svg';
import fb from '../../images/landing/fb.svg';
import insta from '../../images/landing/insta.svg';
import x from '../../images/landing/x logo.svg';
import linkin from '../../images/landing/linkin.svg';
import footerlogo from '../../images/landing/fotterlogo.svg';
import mobilemap from '../../images/landing/mindmap.svg';
import flowdiagrams from '../../images/landing/mobileDesktopNetwork.png';
// import flowdiagrams from '../../images/landing/refferarmy.svg';
import textData from '../../images/landing/textData.svg';
import refretower from '../../images/landing/referimg.svg';
// import mobileview from '../../images/landing/new-updated-mobile-img.png';
import mobileview from '../../images/landing/businessMobile.svg';
import leftMobileView from '../../images/landing/referrerMobile.svg';
import leftarrow from '../../images/landing/left-arrrow.svg';
import rightarrow from '../../images/landing/right-arrow.svg';
import 'aos/dist/aos.css'; // Import AOS styles
import AOS from 'aos';
const Home = () => {
    const [mobilemenu, setmobilemenu] = useState(false);
    const [activePlan, setActivePlan] = useState('Yearly'); // Default selected is 'Multi Site'
    const navigate = useNavigate();
    const scrollRef = useRef(null);

    const handleCardClick = (plan: any) => {
        setActivePlan(plan); // Update the active plan based on the clicked card
    };

    useEffect(() => {
        const hash = window.location.hash;
        if (hash) {
            const element = document.querySelector(hash);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }, []);

    const handleLinkClick = (
        e: React.MouseEvent<HTMLAnchorElement>,
        hash: string
    ) => {
        e.preventDefault(); // Prevent default anchor behavior
        const element = document.querySelector(hash);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    
    useEffect(() => {
        AOS.init();
    }, []);
    function handelmobileMenu() {
        setmobilemenu(!mobilemenu);
    }
    return (
        <div className="landIngPage">
            <header>
                <div className="container">
                    <div className="landingHeader">
                        <div className="headerContent">
                            <div className="sitelogo">
                                <img src={longlogo} alt="sitelogo" />
                            </div>
                            <div
                                className={`navigations ${
                                    mobilemenu ? 'activated' : ''
                                }`}
                            >
                                <ul>
                                    <li>
                                        <Link to="/">Home</Link>
                                    </li>
                                    <li>
                                        <Link
                                            to="#about"
                                            onClick={(e) =>
                                                handleLinkClick(e, '#about')
                                            }
                                        >
                                            About
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            to="/"
                                            onClick={(e) =>
                                                handleLinkClick(e, '#process')
                                            }
                                        >
                                            Our Process
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            to="#"
                                            onClick={(e) =>
                                                handleLinkClick(
                                                    e,
                                                    '#plans-section'
                                                )
                                            }
                                        >
                                            Our Plans
                                        </Link>
                                    </li>
                                    <li>
                                        <NavLink to="/contact-us">
                                            Contact Us
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink to="/refer-us-network">
                                            ReferUs Network
                                        </NavLink>
                                    </li>
                                </ul>
                            </div>
                            <div className="ctas">
                                <button
                                    className="togglemenu"
                                    onClick={handelmobileMenu}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="12"
                                        viewBox="0 0 16 12"
                                        fill="none"
                                    >
                                        <path
                                            d="M15 0.76001L1 0.76003M15 5.76001H1M15 10.76H1"
                                            stroke="white"
                                            stroke-width="1.25"
                                            stroke-linecap="round"
                                        />
                                    </svg>
                                </button>
                                <button
                                    className="btn btn-primary"
                                    onClick={() =>
                                        window.open(
                                            `${adminWebUrl}/login`,
                                            '_self'
                                        )
                                    }
                                >
                                    Log In
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            <section className="mainBanner">
                <div className="container">
                    <h1>
                        What’s the <span>best way</span> to market your business
                    </h1>
                    <h4>Manage your Word-of-Mouth Referrals</h4>
                    <p>
                        Get your happy clients referring you with the ReferUs
                        Network ®. When it comes to marketing your business
                        there's no one better than your happy customers and your
                        raving fans!
                    </p>
                    <div className="btnsgroups">
                        <button
                            className="btn btn-primary"
                            onClick={() => navigate('/register')}
                        >
                            Sign Up Now
                        </button>
                        <button
                            className="btn btn-outline"
                            onClick={() => navigate('/contact-us')}
                        >
                            Find Out More
                        </button>
                        <button
                            className="btn btn-outline w-100 width-max-btn"
                            onClick={() => navigate('/refer-us')}
                        >
                            Refer ReferUs and Earn Click Here
                        </button>
                        {/* <button className="btn btn-outline" onClick={() => navigate('/refer-us')}>
                            Click Here
                        </button> */}
                    </div>

                    {/* <p className="lowertext">Refer the <span>ReferUs</span> Network and get Rewarded</p> */}
                </div>
            </section>
            <section ref={scrollRef} className="aboutus" id="about">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-sm-12">
                            <div className="aboutSideImg">
                                <img src={aboutus} alt="aboutus" />
                            </div>
                        </div>
                        <div className="col-lg-6 col-sm-12">
                            <h2 className="headings">
                                All About <span>Us</span>
                            </h2>
                            <ul className="listDesign">
                                <li>
                                    When you register to become a ReferUs
                                    Network ® company you are gaining the tools
                                    to market and network your business.
                                </li>
                                <li>
                                    Obtain new clients through our comprehensive
                                    and easy referral process. You will have
                                    your very own ReferUs Network landing page
                                    with your branding and logo. All you do is
                                    promote your ReferUs business page to your
                                    networks and customers and raving fans. You
                                    can also promote your business on all the
                                    Social Media platforms to gain an army or
                                    referrers for your business. This now
                                    magnifies your reach and the potential for
                                    more customers / clients.
                                </li>
                                <li>
                                    Once a referrer for your business registers
                                    via your ReferUs page, they receive a
                                    personalised link that they save to the home
                                    screen of their mobile phone. This is so
                                    they can easily refer you to new potential
                                    clients right from their phones!
                                </li>
                                <li>
                                    Now your army of referrers for your business
                                    can instantly refer a new and potential
                                    customer / client to you as they are having
                                    their conversation about how amazing you are
                                    as a business. IT’S INSTANT REFERRALS!
                                </li>
                                <li>
                                    Your customers / clients send you hot leads.
                                    It’s that simple!
                                </li>
                                <li>
                                    All the referrals from your agents are
                                    managed in your very own Admin section. An
                                    Incentive rewards page is also provided
                                    which gives your referrers an even better
                                    reason to promote your business for you.
                                </li>
                                <li>
                                    It's the cheapest and best way to market
                                    your business. You leverage your networks
                                    and happy clients to promote your business
                                    and take it to the next level
                                </li>
                                <li>
                                    Your customers and raving fans now become
                                    your greatest salespeople for your business.
                                </li>
                            </ul>
                            <div className="btnsgroups aboutUs">
                                <Link
                                    to="/register"
                                    className="btn btn-primary h-auto"
                                >
                                    Sign Up Now
                                </Link>
                                <Link
                                    to="/refer-us"
                                    className="btn btn-outline h-auto btn-color-outline"
                                >
                                    Refer ReferUs
                                </Link>
                                <Link
                                    to="/contact-us"
                                    className="btn btn-primary h-auto"
                                >
                                    Contact Us
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="solution">
                <div className="container">
                    <div className="text-center">
                        <h2 className="headings">
                            The Challenge <span>& Our Solution</span>
                        </h2>
                    </div>
                    <div className="row rowRevreseapplied">
                        <div className="col-lg-6 col-sm-12">
                            <div className="problembanner banner1">
                                <img src={prblmbanner} alt="imgs" />
                            </div>
                        </div>
                        <div className="col-lg-6 col-sm-12">
                            <div className="sidetextsol">
                                <h3>What is the problem?</h3>
                                <h5>
                                    Word of Mouth Referrals process is
                                    unstructured:
                                </h5>
                                <ul className="listDesign">
                                    <li>
                                        Many rely on a paper process (and those
                                        being handled correctly)
                                    </li>
                                    <li>
                                        Some rely on a salesperson asking “And
                                        how did you hear about us” or the
                                        customer putting in that information.
                                    </li>
                                    <li>
                                        The process relies on the referrer
                                        remembering and communicating the right
                                        information about the business they are
                                        referring to the customer. This is where
                                        most great potential customers for your
                                        business get told the wrong information
                                        by your referrer.
                                    </li>
                                    <li>
                                        There is no way a business can follow up
                                        a referral or provide them with
                                        information until that referral contacts
                                        the business.
                                    </li>
                                </ul>
                                <h5>
                                    A Word of Mouth Referral strategy is
                                    difficult to implement and execute:
                                </h5>
                                <ul className="listDesign">
                                    <li>
                                        It’s rare that your customers / clients
                                        would carry around information to
                                        promote your business on the off chance
                                        someone asks about it.
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-30">
                        <div className="col-lg-6 col-sm-12">
                            <div className="sidetextsol">
                                <h3>What is the solution</h3>
                                <h5>ReferUs is the solution</h5>
                                <ul className="listDesign">
                                    <li>
                                        All the driving forces of purchasing
                                        decisions can now be found in one simple
                                        affordable solution
                                    </li>
                                </ul>
                                <h5>
                                    Your own branded Mobile Application and CRM
                                    Database system
                                </h5>
                                <ul className="listDesign">
                                    <li>
                                        ReferUs equips and incentivises your
                                        customers to recommend your business via
                                        a personal recommendation.
                                    </li>
                                    <li>
                                        Turn each of your existing customers
                                        (and fans) into a sales force, a lead
                                        generating machine with an easy - to -
                                        use Web App!
                                    </li>
                                    <li>
                                        The Web App is fully customised to your
                                        business and manages your customers’
                                        natural word of mouth referral process.
                                    </li>
                                    <li>Instant referrals at your fingertips</li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-6 col-sm-12">
                            <div className="problembanner banner2">
                                <img src={solbanner} alt="imgs" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="aboutprocess" id="process">
                <div className="container">
                    <div className="text-center">
                        <h2 className="headings">
                            All About Our <span>Process</span>
                        </h2>
                        <p className="customeheads">
                            Within this pack, we’re going to refer to a number
                            of basic players / terms / abbreviations. They are
                            described below for clarity.
                        </p>
                    </div>
                    <div className="row mt-30">
                        <div className="col-lg-4 col-md-6 col-sm-12">
                            <div className="cardswhite">
                                <img src={referrals} alt="icon" />
                                <div className="title">My Referrals</div>
                                <div className="cardContent">
                                    This is a list of all the customers that
                                    your referrers have referred you to. It also
                                    manages the referrer's rewards
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12">
                            <div className="cardswhite">
                                <img src={Referrers} alt="icon" />
                                <div className="title">My Referrers</div>
                                <div className="cardContent">
                                    Here you can find the complete list of your
                                    army of referrers for your business.
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12">
                            <div className="cardswhite">
                                <img src={CompaniesIRefer} alt="icon" />
                                <div className="title">Businesses I Refer</div>
                                <div className="cardContent">
                                    You can use your ReferUs Network® to refer
                                    other businesses as well.
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12">
                            <div className="cardswhite">
                                <img src={referus} alt="icon" />
                                <div className="title">Refer ReferUs</div>
                                <div className="cardContent">
                                    Refer to the ReferUs Network and get month
                                    free on your subscription every time your
                                    referral is successful.
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12">
                            <div className="cardswhite">
                                <img src={InviteReferrer} alt="icon" />
                                <div className="title">Invite A Referrer</div>
                                <div className="cardContent">
                                    Invite your happy customers, raving fans and
                                    friends to be a referrer for your business.
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12">
                            <div className="cardswhite">
                                <img src={social} alt="icon" />
                                <div className="title">Social Media</div>
                                <div className="cardContent">
                                    Invite your happy customers, friends and
                                    your followers to be a referrer for you.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="referusnetwork">
                <div className="container">
                    <div className="text-center">
                        <h2 className="headings">
                            Introducing The<span> ReferUs Network</span>
                        </h2>
                        <p className="customeheads">
                            The ReferUs Network ® is a platform that enables you
                            to connect with other ReferUs businesses and
                            referrals, allowing you to promote your business and
                            offerings to potential referral partners.
                        </p>
                        <div className="desktopView">
                            <img
                                className="w-100 mt-30"
                                src={textData}
                                alt="textData"
                            />
                        </div>
                        <div className="mobileView">
                            <div className="mobiletowerIcons">
                                <img src={refretower} alt="icons" />
                            </div>

                            <div className="networkCards">
                                <div className="networkhead">
                                    Increase Visibility:
                                </div>
                                <div className="networkcontent">
                                    Regularly publishing blog posts helps your
                                    business stay visible to other likeminded
                                    businesses on the platform, keeping your
                                    brand at the top of your mind.
                                </div>
                            </div>
                            <div className="networkCards">
                                <div className="networkhead">
                                    Encourage Engagement:
                                </div>
                                <div className="networkcontent">
                                    Blogs invite comments,shares, and
                                    discussions, promoting interaction with
                                    other businesses and strengthening your
                                    network connections
                                </div>
                            </div>
                            <div className="networkCards">
                                <div className="networkhead">
                                    Networking Opportunities:
                                </div>
                                <div className="networkcontent">
                                    Engaging with a community of similar
                                    businesses through your blog can foster
                                    relationships, leading to potential
                                    partnerships, collaborations, or referral
                                    opportunities.
                                </div>
                            </div>
                            <div className="networkCards">
                                <div className="networkhead">
                                    Showcase Success Stories:
                                </div>
                                <div className="networkcontent">
                                    Highlighting case studies, testimonials, or
                                    successful collaborations can build social
                                    proof and encourage others to work with or
                                    refer your business.
                                </div>
                            </div>
                            <div className="networkCards">
                                <div className="networkhead">
                                    Build Trust and Credibility:
                                </div>
                                <div className="networkcontent">
                                    Consistent, high-quality content builds
                                    trust with other businesses, making them
                                    more likely to refer you or collaborate with
                                    your company.
                                </div>
                            </div>
                            <div className="networkCards">
                                <div className="networkhead">
                                    Content for CrossPromotion:
                                </div>
                                <div className="networkcontent">
                                    Your blog content can be repurposed and
                                    shared across other channels, like social
                                    media or email newsletters, further
                                    amplifying your reach within The ReferUs
                                    Network.
                                </div>
                            </div>
                            <div className="networkCards">
                                <div className="networkhead">
                                    Drive Traffic and Leads:
                                </div>
                                <div className="networkcontent">
                                    By sharing valuable insights and solutions,
                                    you can attract more visitors to your
                                    profile, potentially converting them into
                                    leads or referrers.
                                </div>
                            </div>
                            <div className="networkCards">
                                <div className="networkhead">
                                    Support the Community:
                                </div>
                                <div className="networkcontent">
                                    By providing valuable content, you
                                    contribute to the growth and success of the
                                    business community on the platform, which
                                    can lead to reciprocal benefits.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="buildarmy">
                <div className="container">
                    <div className="text-center">
                        <h2 className="headings">
                            Build Your Army<span> Of Referrers</span>
                        </h2>
                    </div>
                    <img
                        className="w-100 mt-30 px-2"
                        src={flowdiagrams}
                        alt="flowdigram"
                    />
                    <div className="row stepsofDiagram">
                        <div className="col-lg-3 col-sm-12 text-center">
                            <div className="stepheading">Step 1</div>
                            <div className="stepcontent">
                                The business invites people to become referrers
                            </div>
                        </div>
                        <div className="col-lg-3 col-sm-12 text-center">
                            <div className="stepheading">Step 2</div>
                            <div className="stepcontent">
                                Referrers sign up and bookmark the app on their
                                phone (at no charge to them)
                            </div>
                        </div>
                        <div className="col-lg-3 col-sm-12 text-center">
                            <div className="stepheading">Step 3</div>
                            <div className="stepcontent">
                                Referrers send recommendations out to referrals,
                                who receive rewards (determined by the business)
                                on successful referrals
                            </div>
                        </div>
                        <div className="col-lg-3 col-sm-12 text-center">
                            <div className="stepheading">Step 4</div>
                            <div className="stepcontent">
                                All referrers and referrals are managed in your
                                own CRM Database Admin section.
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* new section */}
            <section className="mobile-sec">
                <div className="container">
                    <div className="text-center">
                        <h2 className="headings">
                            ReferUs <span>Business </span> and Referrer{' '}
                            <span>Application</span>
                        </h2>
                    </div>
                    <div className="parent-div">
                        <div className="row">
                            <div className="col-xl-6 col-lg-12 ">
                                <div className="left-wrap">
                                    <div className="text-div">
                                        <p className="refer-text">
                                            As a referUs business you also get{' '}
                                            <span>
                                                your own personlised Mobile
                                                Application
                                            </span>{' '}
                                            where you can manage:
                                        </p>
                                        <h4>- All your referrals</h4>
                                        <h4>- All the people referring you </h4>
                                        <h4>- All the business you refer</h4>
                                        <h4>- Refer ReferUs</h4>
                                        <h4>- Invite a new referrer</h4>
                                        <h4>
                                            - Promote your business on social
                                            media.
                                        </h4>
                                        <h4>
                                            {' '}
                                            - See all other ReferUs business on
                                            the ReferUs Network.
                                        </h4>
                                    </div>
                                    <div className="mobile-div text-center">
                                        <h2 className="text-center">
                                            The ReferUs business <br />{' '}
                                            <span>Mobile Application</span>
                                        </h2>
                                        <img
                                            src={mobileview}
                                            alt="icon"
                                            className="right-wrap-img"
                                        />
                                    </div>
                                </div>
                                <div className="logo-text">
                                    <img
                                        src={leftarrow}
                                        alt="icon"
                                        className="left-img"
                                    />
                                    <p >Your logo here</p>
                                    <img
                                        src={rightarrow}
                                        alt="icon"
                                        className="left-img"
                                    />
                                </div>
                            </div>
                            <div className="col-xl-6 col-lg-12">
                                <div className="right-wrap">
                                    <div className="mobile-div text-center">
                                        <h2 className="text-center">
                                            The ReferUs Referrer <br />{' '}
                                            <span>Mobile Application</span>
                                        </h2>
                                        <img
                                            src={leftMobileView}
                                            alt="icon"
                                            className="right-wrap-img"
                                            style={{height: "417px", width: "369px"}}
                                        />
                                    </div>
                                    <div className="text-div">
                                        <p className="refer-text">
                                            <span>A referUs business </span>{' '}
                                            invites current happy customers,
                                            friends, family etc to become a
                                            referrer for your business and they
                                            also get their own Mobile
                                            Application{' '}
                                            <span>(with your brand)</span> where
                                            they can manage:
                                        </p>
                                        <h4>
                                            - Send a new referral{' '}
                                            <span>in seconds</span>
                                        </h4>
                                        <h4>- All the people referring you </h4>
                                        <h4>- All the business they refer</h4>
                                        <h4>- Refer ReferUs</h4>
                                        <h4>- See all the referrals.</h4>
                                        <h4>
                                            - Promote your business on social
                                            media.
                                        </h4>
                                        <h4>
                                            - See all other ReferUs business on
                                            the ReferUs Network.
                                        </h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* new section */}

            <section className="subsplans" id="plans-section">
                <div className="container">
                    <div className="text-center">
                        <h2 className="headings">
                            One Affordable<span> Plan for Your Needs</span>
                        </h2>
                        <p className="customeheads">
                            For the cost of a small advertisement in a local
                            paper you can purchase a marketing tool that can
                            transform your business. Business can purchase the
                            system either Monthly or Yearly. White label and
                            corporate solutions also available .
                        </p>
                        <div className="cardblock">
                            <div
                                className={`cardsubs ${
                                    activePlan === 'Monthly'
                                        ? 'active aos-init aos-animate'
                                        : 'aos-init aos-animate'
                                }`}
                                data-aos="flip-left"
                                data-aos-duration="115000"
                                onClick={() => handleCardClick('Monthly')}
                            >
                                <div className="cardfirstTitle">Monthly</div>
                                <div className="cardSecondTitle">$35*</div>
                                <div className="geryblocked">
                                    <ul className="listnew">
                                        <li>ReferUs Admin Platform**</li>
                                        <li>ReferUs Mobile application</li>
                                        <li>ReferUs Network Platform</li>
                                        <li>
                                            Personalised QR Code and URL to
                                            promote on social media
                                        </li>
                                    </ul>
                                    <div className="text-center">
                                        <button
                                            onClick={() =>
                                                navigate('/register', {
                                                    state: {
                                                        selectedPlan: 'monthly',
                                                    },
                                                })
                                            }
                                            className="chooseplan"
                                        >
                                            Choose Plan
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div
                                className={`cardsubs ${
                                    activePlan === 'Yearly'
                                        ? 'active aos-init aos-animate'
                                        : 'aos-init aos-animate'
                                }`}
                                data-aos="flip-left"
                                data-aos-duration="115000"
                                onClick={() => handleCardClick('Yearly')}
                            >
                                <div className="cardfirstTitle">Yearly</div>
                                <div className="cardSecondTitle">$375*</div>
                                <div className="geryblocked">
                                    <ul className="listnew">
                                        <li>ReferUs Admin Platform**</li>
                                        <li>ReferUs Mobile application</li>
                                        <li>ReferUs Network Platform</li>
                                        <li>
                                            Personalised QR Code and URL to
                                            promote on social media
                                        </li>
                                    </ul>
                                    <div className="text-center">
                                        <button
                                            onClick={() =>
                                                navigate('/register', {
                                                    state: {
                                                        selectedPlan: 'yearly',
                                                    },
                                                })
                                            }
                                            className="chooseplan"
                                        >
                                            Choose Plan
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div
                                className={`cardsubs ${
                                    activePlan === 'Multi Site'
                                        ? 'active aos-init aos-animate'
                                        : 'aos-init aos-animate'
                                }`}
                                data-aos="flip-left"
                                data-aos-duration="115000"
                                onClick={() => handleCardClick('Multi Site')}
                            >
                                <div className="cardfirstTitle">Multi Site</div>
                                <div className="cardSecondTitle">$300* p/y</div>
                                <div className="geryblocked">
                                    <ul className="listnew">
                                        <li>ReferUs Admin Platform**</li>
                                        <li>ReferUs Mobile application</li>
                                        <li>ReferUs Network Platform</li>
                                        <li>
                                            Personalised QR Code and URL to
                                            promote on social media
                                        </li>
                                        <li>
                                            For business with more than 10 sites
                                            up to 100 sites
                                        </li>
                                    </ul>
                                    <div className="text-center">
                                        {/* <button onClick={() => navigate('/register', { state: { selectedPlan: 'multi-site' } })} className="chooseplan">Choose Plan</button> */}
                                        <button
                                            onClick={() =>
                                                navigate('/contact-us')
                                            }
                                            className="chooseplan"
                                        >
                                            Contact Us
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div
                                className={`cardsubs ${
                                    activePlan === 'Corporate'
                                        ? 'active aos-init aos-animate'
                                        : 'aos-init aos-animate'
                                }`}
                                data-aos="flip-left"
                                data-aos-duration="115000"
                                onClick={() => handleCardClick('Corporate')}
                            >
                                <div className="cardfirstTitle">Corporate</div>
                                <div className="cardSecondTitle">
                                    Contact Us
                                </div>
                                <div className="geryblocked">
                                    <ul className="listnew">
                                        <li>
                                            For Organisations, Associations or
                                            Franchises
                                        </li>
                                    </ul>
                                    <div className="text-center">
                                        <button
                                            onClick={() =>
                                                navigate('/contact-us')
                                            }
                                            className="chooseplan"
                                        >
                                            Contact Us
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <p className="customeheads">
                            * Tax not included <br />
                            <p>
                                ** Monthly: allows for 500 referrers, then
                                $15.00 for every 500 referrers <br />
                                Yearly: allows for 500 referrers, then $180.00
                                for every 500 referrers
                            </p>
                        </p>
                    </div>
                </div>
            </section>
            <section className="keyfeatures">
                <div className="container">
                    <div className="text-center">
                        <h2 className="headings">
                            5 Key Sources<span> Of ReferUs</span>
                        </h2>
                    </div>
                </div>
                <div className="keyfeatures imgSection">
                    <div className="container">
                        <img className="w-100" src={mobilemap} alt="diagram" />
                    </div>
                </div>
            </section>
            <section className="worldwide">
                <div className="container">
                    <div className="text-center">
                        <h2 className="headings">
                            ReferUs can be used <span>by any business</span>
                        </h2>
                        <p className="customeheads">
                            No matter what type of business you have, you can
                            use Refer Us to grow your business!
                        </p>
                    </div>
                    <div className="container">
                        <img
                            className="mapsDesign w-100"
                            src={maps}
                            alt="map"
                        />
                    </div>
                </div>
            </section>
            <footer>
                <div className="outerfooter">
                    <div className="container">
                        <div className="whitefooters">
                            <div className="textparts">
                                ReferUs Network :{' '}
                                <span>Grow your business with ReferUs</span>
                            </div>
                            <Link className="btn btn-primary h-auto" to="/register">
                                Sign Up Now
                            </Link>
                        </div>
                    </div>
                </div>

                <div className="fottercontent">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-3 col-sm-12">
                                <div className="sitelogo">
                                    <img src={footerlogo} alt="sitelogo" />
                                </div>
                                <p>
                                    Get your happy clients referring you with
                                    ReferUs
                                </p>
                                <div className="socialIcons">
                                    <a href="#" target="_blank">
                                        <img src={fb} alt="facebook" />
                                    </a>
                                    <a href="#" target="_blank">
                                        <img src={insta} alt="instagram" />
                                    </a>
                                    <a href="#" target="_blank">
                                        <img src={x} alt="x" />
                                    </a>
                                    <a href="#" target="_blank">
                                        <img src={linkin} alt="LinkedIn" />
                                    </a>
                                </div>
                            </div>
                            <div className="col-lg-3 col-sm-6 col-6 links">
                                <h3>Quick Links</h3>
                                <Link
                                    to="#about"
                                    onClick={(e) =>
                                        handleLinkClick(e, '#about')
                                    }
                                >
                                    About
                                </Link>
                                <Link
                                    to="/"
                                    onClick={(e) =>
                                        handleLinkClick(e, '#process')
                                    }
                                >
                                    Process{' '}
                                </Link>
                                <Link
                                    to="/"
                                    onClick={(e) =>
                                        handleLinkClick(e, '#plans-section')
                                    }
                                >
                                    Plans
                                </Link>
                                <Link to="/contact-us">Contact</Link>
                            </div>
                            <div className="col-lg-3 col-sm-6 col-6 links">
                                <h3>Contact </h3>
                                <Link to="/contact-us">Contact Us</Link>
                                <a
                                    href="/privacy-policy"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Privacy Policy
                                </a>
                                <a
                                    href="/terms-and-conditions"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Terms & Conditions
                                </a>

                                <Link
                                    to="#"
                                    onClick={(e) => {
                                        e.preventDefault(); // Prevents React Router's internal navigation
                                        window.open(
                                            `${adminWebUrl}/login`,
                                            '_blank'
                                        );
                                    }}
                                >
                                    Sign In
                                </Link>
                                <Link to="/register">Register</Link>
                            </div>
                            <div className="col-lg-3 col-sm-12">
                                <h3>Subscribe Our Newsletter </h3>
                                <div className="subscriptionletter">
                                    <form>
                                        <input
                                            type="text"
                                            placeholder="Enter Your Email Here"
                                        />
                                        <button className="arrow button">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="25"
                                                viewBox="0 0 24 25"
                                                fill="none"
                                            >
                                                <path
                                                    d="M21.5 3.33984L14.85 22.3398L11.05 13.7898L2.5 9.98984L21.5 3.33984Z"
                                                    stroke="#F47523"
                                                    stroke-width="2"
                                                    stroke-linejoin="round"
                                                />
                                                <path
                                                    d="M21.4998 3.33984L11.0498 13.7898"
                                                    stroke="#F47523"
                                                    stroke-width="2"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                />
                                            </svg>
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="text-center copyright">
                        © {new Date().getFullYear()} ReferUs , All rights
                        reserved
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default Home;
